/**
 * «Продолжить в фоне» — отпустить виджет, пока генерация идёт (план «Ждём ответа нейросети», Ф2, 26.09).
 *
 * Генерация уходит в стикер незакрытых генераций и сама дожидается ответа сервера, а виджет свободен для
 * следующей. Раньше виджет отпускал таймаут опроса (24 минуты, «Таймаут генерации»), пока нейросеть ещё
 * рисовала; без таймаута долгая генерация держала бы виджет часами — теперь решает человек, а не часы.
 * Ставится рядом с «Создать» (CreateButton) на время генерации; логика — gen.detachGeneration.
 */
interface Props {
	onClick: () => void
	className?: string
}

export default function DetachButton({ onClick, className = '' }: Props) {
	return (
		<button
			type="button"
			className={`gm__detach${className ? ` ${className}` : ''}`}
			onClick={onClick}
			aria-label="Продолжить в фоне"
			title="Генерация продолжится в фоне и будет ждать в стикере — можно запускать следующую"
		>
			<span className="gm__detach-label">Продолжить в фоне</span>
			<span className="gm__detach-short" aria-hidden="true">В фон</span>
		</button>
	)
}
